module.exports = __webpack_public_path__ + "img/left-btn.d2f86194.png";